import { ChevronLeft32, ChevronRight32 } from '@carbon/icons-react';
import React from 'react';
import cx from 'classnames';
import { useMediaQuery, smMediaQuery, } from '@mercell/use-media-query-react-hook';
import { twMerge } from 'tailwind-merge';
import { DOTS, usePagination } from './usePagination';
var paginationItemClasses = 'py-0 px-2 align-center flex items-center text-body';
var arrowButtonClassName = 'font-normal text-valhalla hover:underline';
var mobileViewClassName = 'py-0 px-0.5 font-normal text-dove';
var disabledClassNameToggle = 'text-alto cursor-default';
var Pagination = function (_a) {
    var totalCount = _a.totalCount, currentPage = _a.currentPage, pageSize = _a.pageSize, onPageChange = _a.onPageChange, siblingCount = _a.siblingCount, className = _a.className, ariaLabels = _a.ariaLabels;
    var paginationRange = usePagination({
        currentPage: currentPage,
        totalCount: totalCount,
        siblingCount: siblingCount,
        pageSize: pageSize,
    });
    var isNotDesktop = useMediaQuery(smMediaQuery);
    if (currentPage === 0 || paginationRange.length < 2) {
        return null;
    }
    var onNext = function () {
        onPageChange(currentPage + 1);
    };
    var onPrevious = function () {
        onPageChange(currentPage - 1);
    };
    var lastPage = paginationRange[paginationRange.length - 1];
    if (isNotDesktop) {
        return (React.createElement("nav", { className: twMerge('w-fit-content', mobileViewClassName, className), role: "navigation", "aria-label": "pagination" },
            React.createElement("ul", { className: "flex" },
                React.createElement("li", { className: cx(paginationItemClasses, mobileViewClassName) },
                    React.createElement("button", { type: "button", "aria-disabled": currentPage === 1, "aria-label": (ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.prevPageButton) ||
                            'Go to previous page', className: twMerge(arrowButtonClassName, 'py-0 px-0.5', currentPage === 1 && disabledClassNameToggle), disabled: currentPage === 1, onClick: onPrevious, tabIndex: 0 },
                        React.createElement(ChevronLeft32, null))),
                React.createElement("li", { className: cx(paginationItemClasses, 'text-valhalla py-0 px-0.5') }, currentPage),
                React.createElement("li", { className: cx(paginationItemClasses, mobileViewClassName) },
                    "/ ",
                    lastPage),
                React.createElement("li", { className: cx(mobileViewClassName, paginationItemClasses) },
                    React.createElement("button", { type: "button", disabled: currentPage === lastPage, "aria-disabled": currentPage === lastPage, "aria-label": (ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.nextPageButton) || 'Go to next page', className: twMerge(arrowButtonClassName, currentPage === lastPage &&
                            disabledClassNameToggle), tabIndex: 0, onClick: onNext },
                        React.createElement(ChevronRight32, null))))));
    }
    return (React.createElement("nav", { className: twMerge('w-fit-content', className), role: "navigation", "aria-label": "pagination" },
        React.createElement("ul", { className: "flex" },
            React.createElement("li", { className: paginationItemClasses },
                React.createElement("button", { type: "button", "aria-disabled": currentPage === 1, "aria-label": (ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.prevPageButton) || 'Go to previous page', className: twMerge(arrowButtonClassName, currentPage === 1 && disabledClassNameToggle), disabled: currentPage === 1, onClick: onPrevious, tabIndex: 0 },
                    React.createElement(ChevronLeft32, null))),
            paginationRange.map(function (pageNumber, index) {
                if (pageNumber === DOTS) {
                    return (React.createElement("li", { key: "".concat(pageNumber, "_").concat(index < paginationRange.length / 2
                            ? 'first'
                            : 'last'), className: cx(paginationItemClasses, 'hover:bg-transparent hover:cursor-default') },
                        React.createElement("div", null, "\u2026")));
                }
                return (React.createElement("li", { key: pageNumber, className: paginationItemClasses },
                    React.createElement("button", { type: "button", "aria-current": pageNumber === currentPage, "aria-label": (ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.pageButton) ||
                            "Go to page ".concat(pageNumber, " "), onClick: function () {
                            return onPageChange(pageNumber);
                        }, className: cx('font-normal text-dove hover:underline', {
                            'text-mirage font-semibold hover:no-underline': pageNumber === currentPage,
                        }), tabIndex: 0 }, pageNumber)));
            }),
            React.createElement("li", { className: paginationItemClasses },
                React.createElement("button", { type: "button", disabled: currentPage === lastPage, "aria-disabled": currentPage === lastPage, "aria-label": (ariaLabels === null || ariaLabels === void 0 ? void 0 : ariaLabels.nextPageButton) || 'Go to next page', className: twMerge(arrowButtonClassName, currentPage === lastPage && disabledClassNameToggle), tabIndex: 0, onClick: onNext },
                    React.createElement(ChevronRight32, null))))));
};
export { Pagination };
